<template>
    <div class="tabBox relative"> {{title}}<span class="tab" v-if="num!=-1" >{{num}}</span> </div>
</template>

<script>
export default {
    name:'Dot',
    props:{
        title:String,
        num:String|Number
    }
}
</script>

<style lang="stylus" scoped>
.tabBox{
  .tab{
    position :absolute;
    top:-10px;
    padding:5px;
    border-radius:50%;
    background-color :red;
    font-size:12px;
    zoom :.6;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/dot.vue